import React, { forwardRef } from "react";
import { useSearch } from "../../../Contexts/SearchContext";

const FilterDrawerButtons =  forwardRef((props,ref) => {
  const { state, dispatch } = useSearch();

  const resetFilters = () => {
    let productFinder = document.querySelector(".cmp-product-finder");
    let checkboxes = productFinder.querySelectorAll(
      '.cmp-product-finder input[type="checkbox"]:checked',
    );
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked === true) {
        checkbox.checked = false;
        let event = document.createEvent("HTMLEvents");
        event.initEvent("change", false, true);
        checkbox.dispatchEvent(event);
        checkbox
          .closest(".cmp-accordion__item, .cmp-accordion__sub-item")
          .querySelector(
            ".cmp-accordion__selected-filters-heading",
          ).textContent = "";
      }
    });

    productFinder
      .querySelectorAll(
        ".cmp-accordion__item.open>.cmp-accordion__title-button,.cmp-accordion__sub-item.open>.cmp-accordion__title-button",
      )
      .forEach((item) => {
        item.click();
      });

    dispatch({ type: "UPDATE_SELECTED_FILTERS", payload: [] });
    dispatch({ type: "UPDATE_RESULTS_TO_SHOW_MOBILE", payload: 6 });
    dispatch({ type: "UPDATE_RESULTS_TO_SHOW_TABLET", payload: 8 });
    dispatch({ type: "UPDATE_RESULTS_TO_SHOW_DESKTOP", payload: 12 });
  };

  return (
    <div ref={ref} className="cmp-filter-drawer-content__buttons p1 -semi-bold">
      <div className="button button--primary">
        <button
          className="cmp-button cmp-button__see-results"
          onClick={() => {
            dispatch({ type: "UPDATE_FILTER_DRAWER_IS_OPEN", payload: false });
          }}
        >
          SEE RESULTS
        </button>
      </div>
      <div className="button button--secondary cmp-button__reset-filters">
        <button className="cmp-button" onClick={resetFilters}>
          Reset Filters
        </button>
      </div>
    </div>
  );
});

export default FilterDrawerButtons;
